import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class CityService {
  static ENDPOINT = `${BASE}/city`;

  static async getByCountry(countryId) {
    if (!countryId) return [];
    return await request({
      url: `${this.ENDPOINT}/country/${encodeURIComponent(countryId)}`,
      auth: false
    });
  }
}

export default CityService;
